module.exports = __webpack_public_path__ + "img/logo-transparente.e16713d5.png";